import useCountryData from '../hooks/useCountryData';

const FormattedCountryName = ({ code }: { code?: string | null }) => {
  const { data } = useCountryData(code);

  return <>{data?.fullNameLocale || code}</>;
};

export default FormattedCountryName;
